import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const InspiredIcon = (props: IconProps) => {
  return (
    <Icon
      fill="none"
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#FFCB4C" d="M36 85a34 34 0 1 0 0-68 34 34 0 0 0 0 68Z" />
      <path
        fill="#65471B"
        d="M29 59a1.8 1.8 0 0 1-.6-1.5 1.6 1.6 0 0 1 1.2-1.4 19 19 0 0 1 15.4 3c.8.5 1 1.6.4 2.3-.6.8-1.7.8-2.5.2-.2-.1-5-3.8-12.3-2.2a1.8 1.8 0 0 1-1.6-.3ZM26.2 44.7c2.4 0 4.3-2.4 4.3-5.4 0-2.9-2-5.3-4.3-5.3S22 36.4 22 39.3c0 3 1.9 5.4 4.2 5.4ZM48.8 46.8c2.3 0 4.2-2.4 4.2-5.3 0-3-1.9-5.3-4.3-5.3-2.3 0-4.2 2.3-4.2 5.3s1.9 5.3 4.3 5.3Z"
      />
      <path
        fill="#F19020"
        d="M34.6 87.3s2.5-.8 2.8-2.7c.4-2-1.2-2.3-1.2-2.3s2-.5 2.3-2.8c.3-2.2-1.7-2.7-1.7-2.7s2-.8 2-3.1c0-2-2-2.9-2-2.9L48 68.2c1-.3 2.7-1.3 2.2-3.4-.5-2.2-2.4-2.3-3.4-2l-17.8 4.1-2.9.7c-1 .2-1.6-.2-.8-1 1-1.1 1.7-2.3 1.9-4.3.2-2-.5-4.6-.9-5.6-.7-1.8-2-3.3-3.4-3.8-2.3-.8-4 .7-3.1 3.1 1.2 3.7.4 6.8-1.7 8.6-4.9 4.3-7.2 7.4-5.7 14a13.3 13.3 0 0 0 16 10l6.3-1.3Z"
      />
      <path
        fill="#65471B"
        d="M18.6 29.7a1.8 1.8 0 0 1-1-1.4 1.6 1.6 0 0 1 1-1.6 19 19 0 0 1 15.7 0c.8.5 1.2 1.5.8 2.4-.5.8-1.5 1-2.4.6-.2-.1-5.6-2.9-12.5 0a1.8 1.8 0 0 1-1.6 0Zm24.3 7.5a1.8 1.8 0 0 1-.9-1.5 1.6 1.6 0 0 1 1-1.5 19 19 0 0 1 15.7 1.1c.8.5 1.1 1.6.6 2.4-.4.8-1.5 1-2.3.5-.3-.2-5.5-3.3-12.6-.8a1.8 1.8 0 0 1-1.5-.2Z"
      />
      <path
        fill="#FFD983"
        d="M76 11c0 6.5-5 7.5-5 13.5 0 3.1-3.1 3.4-5.5 3.4-2 0-6.6-.8-6.6-3.4 0-6-4.9-7-4.9-13.4 0-6 5.3-11 11-11a11 11 0 0 1 11 11Z"
      />
      <path
        fill="#CCD6DD"
        d="M69.2 32.5c0 .8-2.3 2.5-4.2 2.5-2 0-4.2-1.7-4.2-2.5s2.3-.5 4.2-.5c2 0 4.2-.3 4.2.5Z"
      />
      <path
        fill="#FFCC4D"
        d="M69.7 10.3a1 1 0 0 0-1.4 0L65 13.6l-3.3-3.3a1 1 0 1 0-1.4 1.4l3.7 3.7V26a1 1 0 0 0 2 0V15.4l3.7-3.7a1 1 0 0 0 0-1.4Z"
      />
      <path fill="#99AAB5" d="M71 31a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-6h12v6Z" />
      <path
        fill="#CCD6DD"
        d="M59 32a1 1 0 0 1-.2-2l12-2a1 1 0 0 1 1.2 1.2 1 1 0 0 1-.8.8l-12 2H59Zm0-4a1 1 0 0 1-.2-2l12-2a1 1 0 0 1 1.2 1.2 1 1 0 0 1-.8.8l-12 2H59Z"
      />
    </Icon>
  );
};

export default InspiredIcon;
